import { render, staticRenderFns } from "./OrderedList.vue?vue&type=template&id=d696ce00&scoped=true"
import script from "./OrderedList.vue?vue&type=script&lang=ts"
export * from "./OrderedList.vue?vue&type=script&lang=ts"
import style0 from "./OrderedList.vue?vue&type=style&index=0&id=d696ce00&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d696ce00",
  null
  
)

export default component.exports